import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';

import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import teamWorkImage from 'assets/images/cap60-weatherization.jpeg';
import styles from './programs.module.scss';
import RequestDemoButton from 'components/RequestDemoButton';
import { Helmet } from 'react-helmet';
import { SampleReport } from './SampleReport';

const REPORT_DATA = [
  {
    title: '',
    items: [
      'Building Information',
      'Home Inspections',
      'Weatherization Work Orders',
      'Customizable Measures and',
      'NEAT Audit Capable',
    ],
  },
];
const REPORT_DATA2 = [
  {
    title: '',
    items: [
      'Case Completion Status',
      'Contractor by Work Order',
      'Installed Measures',
      'Inventory Usage Per Item',
      'Inventory Totals',
      'Bid Management Analytics',
    ],
  },
];

const FEATURE_DATA = [
  {
    id: 1,
    title: 'Centralized Data Management and Tracking System',
  },
  {
    id: 2,
    title: 'Complete Integration With Other Agency Programs',
  },
  {
    id: 3,
    title: 'Contractors Assessment Module',
  },
  {
    id: 4,
    title: 'Pre- and Post- Assessments',
  },
  {
    id: 5,
    title: 'Real-Time Status Tracking',
  },
  {
    id: 6,
    title: 'Multiple Funding Source Tracking',
  },
  {
    id: 7,
    title: 'Comprehensive Case Management',
  },
  {
    id: 8,
    title: 'Complete Inventory Management',
  },
  {
    id: 9,
    title: 'Track Work Orders, Progress Reports and Payments',
  },
  {
    id: 10,
    title: 'Track Inspections and Tests',
  },
];
function Weatherization() {
  return (
    <div>
      <Helmet>
        <title>Unparalleled Weatherization Data Management - Cap 60</title>
        <meta
          name="description"
          content="The CAP60 weatherization module tracks services, work orders, inventory and more. Call us Now!."
        />
        <meta
          name="keywords"
          content="weatherizaton data management, cap60 weatherizaton data management"
        />
      </Helmet>
      <PageBanner
        title="Weatherization"
        subtitle="Unparalleled Weatherization Data Management"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} title="Reports" className="pb-0" />
      <SampleReport data={REPORT_DATA2} title="Features" className="pt-5" />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>Unparalleled Weatherization Data Management</h2>
          </div>
          <p>
            The CAP60 weatherization module doesn’t stop at collecting client
            data. It also tracks services, work orders, inventory and more. The
            ability to track agency inventory takes the guesswork out of what’s
            on hand. There’s even an assigned external access capability that
            allows contractors to bid on jobs, see they jobs that they’ve won
            and to report on their progress.
          </p>

          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

export default Weatherization;
